import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { ArrowLeft, Building2, Package, DollarSign, FileText, CreditCard, Filter } from "lucide-react";

export const ClientDetailsSkeleton = () => {
    return (
        <div className="min-h-screen bg-muted/50 dark:bg-background animate-pulse">
            {/* Header Skeleton */}
            <header className="border-b bg-foreground text-background">
                <div className="container mx-auto px-6 py-4">
                    <div className="flex items-center gap-4">
                        <Skeleton className="h-10 w-24 bg-muted/20" /> {/* Back Button */}
                        <Skeleton className="h-8 w-1 bg-muted/20" /> {/* Separator */}
                        <div>
                            <Skeleton className="h-8 w-64 mb-1 bg-muted/20" /> {/* Client Name */}
                            <Skeleton className="h-4 w-48 bg-muted/20" /> {/* Client Code */}
                        </div>
                    </div>
                </div>
            </header>

            <main className="container mx-auto px-6 py-8">
                {/* Tabs Skeleton */}
                <div className="grid w-full grid-cols-3 gap-2 mb-6">
                    <Skeleton className="h-10 w-full" />
                    <Skeleton className="h-10 w-full" />
                    <Skeleton className="h-10 w-full" />
                </div>

                {/* Overview Tab Content Skeleton */}
                <div className="space-y-6">
                    {/* Dados Cadastrais Card Skeleton */}
                    <Card className="border-border dark:border-border shadow-lg">
                        <CardHeader>
                            <CardTitle className="flex items-center gap-2">
                                <Building2 className="h-5 w-5 text-muted-foreground" />
                                <Skeleton className="h-6 w-40" />
                            </CardTitle>
                        </CardHeader>
                        <CardContent>
                            <div className="grid gap-6 md:grid-cols-2">
                                {[...Array(4)].map((_, i) => (
                                    <div key={i} className="space-y-2">
                                        <Skeleton className="h-4 w-1/2" />
                                        <Skeleton className="h-6 w-full" />
                                    </div>
                                ))}
                            </div>
                        </CardContent>
                    </Card>

                    {/* Metrics Cards Skeleton */}
                    <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
                        {[...Array(2)].map((_, i) => ( // Only 2 metrics cards in overview
                            <Card key={i}>
                                <CardHeader className="pb-3">
                                    <div className="flex items-center justify-between">
                                        <Skeleton className="h-4 w-3/4" />
                                        <Skeleton className="h-4 w-4" />
                                    </div>
                                </CardHeader>
                                <CardContent>
                                    <Skeleton className="h-8 w-1/2" />
                                    <Skeleton className="h-4 w-2/3 mt-1" />
                                </CardContent>
                            </Card>
                        ))}
                    </div>

                    {/* Top Products Table Skeleton */}
                    <Card className="border-border dark:border-border shadow-lg">
                        <CardHeader>
                            <CardTitle className="flex items-center gap-2">
                                <FileText className="h-5 w-5 text-muted-foreground" />
                                <Skeleton className="h-6 w-48" />
                            </CardTitle>
                            <Skeleton className="h-4 w-1/3 mt-1" />
                        </CardHeader>
                        <CardContent>
                            <Table>
                                <TableHeader>
                                    <TableRow>
                                        {[...Array(4)].map((_, i) => (
                                            <TableHead key={i}><Skeleton className="h-4 w-full" /></TableHead>
                                        ))}
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    {[...Array(3)].map((_, i) => (
                                        <TableRow key={i}>
                                            {[...Array(4)].map((_, j) => (
                                                <TableCell key={j}><Skeleton className="h-5 w-full" /></TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </div>
            </main>
        </div>
    );
};
